import introIcon from '../../assets/images/introIcon.svg';
import missionIcon from '../../assets/images/missionIcon.svg';
import visionIcon from '../../assets/images/visionIcon.svg';

const IntroBlockData = [
  {
    color: 'yellow',
    icon: introIcon,
    heading: 'Introduction',
    description: 'Linum Technologies is leading company in distribution of electrical components and solutions with respect to the customer needs. We believe in customer satisfaction and considering the small values as our achievement by fulfilling them.'
  },
  {
    color: 'blue',
    icon: missionIcon,
    heading: 'Mission',
    description: 'To empower people and businesses throughout the world to comprehend their full potential.'
  },
  {
    color: 'sky-blue',
    icon: visionIcon,
    heading: 'Vision',
    description: 'We aims to revolutionize the technology industry by providing innovative and sustainable solutions that cater to the diverse needs of businesses, while maintaining a strong commitment to customer satisfaction, ethical practices, and continuous growth.'
  },
]
export default IntroBlockData;